import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/adminphu.phucbaokhang.com.vn/httpdocs/app/src/app/(authen)/login/LoginClient.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/adminphu.phucbaokhang.com.vn/httpdocs/app/src/styles/login.css");
